module.exports = __webpack_public_path__ + "static/media/outside2.4b46ea04.png";